import classNames from 'classnames';
import LocationResult from 'src/components/locationresultlist/LocationResult';
import styles from './LocationResultList.module.css';

//#region [Props]
type LocationResultListProps = {
    locationList?: string[];
    maxNumToShow?: number;
    className?: string;
    clickTracker: (locationName: string) => void;
};
//#endregion

//#region [Component]
export default function LocationResultList({ locationList, maxNumToShow = 6, className, clickTracker }: LocationResultListProps) {

    if ((locationList?.length ?? 0) === 0) {
        return null;
    }

    return <section className={classNames(styles.SLocationResultList, className)}>
        <h1 className={styles.SH1}>Treff på kinosteder</h1>
        {locationList!.slice(0, maxNumToShow).map(locationName => (
            <LocationResult
                className={styles.SLocationItem}
                locationName={locationName}
                key={locationName}
                onClick={() => clickTracker(locationName)}
            />
        ))}
    </section>;
}
//#endregion

